import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import youTubePlayer from 'youtube-player';
import carouselConstants from '../constants/carouselConstants';

export type TYoutubePlayerRef = {
  pause: () => void;
};

enum PlayerState {
  Unstarted = -1,
  Ended = 0,
  Playing = 1,
  Paused = 2,
  Buffering = 3,
  Cued = 5
}

const YouTubePlayer = (
  {
    id,
    className,
    onPlay,
    onPaused,
    onEnd
  }: {
    id: string;
    // eslint-disable-next-line react/require-default-props
    className?: string;
    // eslint-disable-next-line react/require-default-props
    onPlay?: (event: CustomEvent<any>) => void;
    // eslint-disable-next-line react/require-default-props
    onPaused?: (event: CustomEvent<any>) => void;
    // eslint-disable-next-line react/require-default-props
    onEnd?: (event: CustomEvent<any>) => void;
  },
  ref: React.Ref<TYoutubePlayerRef>
): JSX.Element => {
  const internalPlayerRef = useRef<ReturnType<typeof youTubePlayer> | undefined>(undefined);

  const onPlayerStateChange = (event: CustomEvent<any> & { data: PlayerState }) => {
    switch (event.data) {
      case PlayerState.Playing:
        if (onPlay) {
          onPlay(event);
        }
        break;
      case PlayerState.Paused:
        if (onPaused) {
          onPaused(event);
        }
        break;
      case PlayerState.Ended:
        if (onEnd) {
          onEnd(event);
        }
        break;

      default:
        break;
    }
  };

  useImperativeHandle(ref, () => ({
    pause: () => {
      internalPlayerRef.current?.pauseVideo();
    }
  }));

  useEffect(() => {
    internalPlayerRef.current = youTubePlayer(id, carouselConstants.youtubePlayerConfigs(id));
    internalPlayerRef.current.on('stateChange', onPlayerStateChange);
    return () => {
      internalPlayerRef.current?.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={className}>
      <div id={id} />
    </div>
  );
};

export default forwardRef(YouTubePlayer);
